import Dashboard from "../components/dashboard";
import SvgIcons from "../../../shared/components/svgIcons";

const dashboardRoute = [
  {
    path: "dashboard",
    element: <Dashboard />,
    link: "dashboard",
    name: "Dashboard",
    permission: "Dashboard",
    icon: SvgIcons.DashBoardIcon,
    index: 0,
  },
];
export default dashboardRoute;
